import React from 'react';
import { StandoutTile } from 'web-ui-components/lib/layout/content';

export const renderCardError = errorMessage => (
  <StandoutTile.Important>
    <p>{errorMessage}</p>
  </StandoutTile.Important>
);
